import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=72d1af5f"
import script from "./DocumentsNew.vue?vue&type=script&lang=ts"
export * from "./DocumentsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d1af5f')) {
      api.createRecord('72d1af5f', component.options)
    } else {
      api.reload('72d1af5f', component.options)
    }
    module.hot.accept("./DocumentsNew.vue?vue&type=template&id=72d1af5f", function () {
      api.rerender('72d1af5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/project/DocumentsNew.vue"
export default component.exports